import { useState } from 'react';
import { CapitolIcon } from '@/icons/capitol-icon';

interface OrgImageProps {
  imageUrl?: string;
  alt?: string;
  className?: string;
  fallbackComponent?: React.ReactNode;
}

export const OrgImage = ({
  imageUrl,
  alt = 'Organization logo',
  className = '',
  fallbackComponent,
}: OrgImageProps) => {
  const [imageError, setImageError] = useState(false);

  // Helper function to check if URL is a placeholder
  const isPlaceholderUrl = (url: string | undefined) => {
    return !url || url.includes('todo:') || url === 'todo: return download_url';
  };

  // Handle image load error
  const handleImageError = () => {
    setImageError(true);
  };

  // Reset error state when URL changes
  const handleImageLoad = () => {
    setImageError(false);
  };

  // Show fallback if URL is placeholder or image failed to load
  if (isPlaceholderUrl(imageUrl) || imageError) {
    return fallbackComponent || <CapitolIcon />;
  }

  return (
    <img
      src={imageUrl}
      alt={alt}
      className={className}
      onError={handleImageError}
      onLoad={handleImageLoad}
    />
  );
};
